import { getLocalEvent } from './localStatisticsEvents';
import localStatisticsActions from './localStatisticsActions';
import { IShoppingItem } from '@inter-ikea-kompis/types/lib';

const localStatisticsReporter = {
  reportAddToBagError: (shoppingItems?: IShoppingItem[]) => {
    const event = getLocalEvent(localStatisticsActions.ADD_TO_BAG_ERROR);
    event.reportEvent(shoppingItems);
  },
  reportAddToListError: (shoppingItems?: IShoppingItem[]) => {
    const event = getLocalEvent(localStatisticsActions.ADD_TO_LIST_ERROR);
    event.reportEvent(shoppingItems);
  },
  reportProductMenuMountingRailInfoClicked: () => {
    const event = getLocalEvent(
      localStatisticsActions.PRODUCT_MENU_MOUNTING_RAIL_INFO_CLICKED
    );
    event.reportEvent();
  },

  reportStartViewSprClick: (sprId: string) => {
    const event = getLocalEvent(localStatisticsActions.START_VIEW_SPR_CLICKED);
    event.reportEvent({ sprId: sprId });
  },
  reportTacArticleClicked: (itemId: string) => {
    const event = getLocalEvent(localStatisticsActions.TAC_ARTICLE_CLICKED);
    event.reportEvent({ item: itemId });
  },
  reportConfMenuInfoButtonClicked: (itemId: string) => {
    const event = getLocalEvent(
      localStatisticsActions.CONF_MENU_INFO_BUTTON_CLICKED
    );
    event.reportEvent({ item: itemId });
  },
  reportConfMenuSliderChange: (width: any, itemId: any) => {
    const event = getLocalEvent(localStatisticsActions.CONF_MENU_SLIDER);
    event.reportEvent({ width: width, item: itemId });
  },
  reportProductMenuSwiperInteraction: (
    { status, item }: any,
    interaction: string
  ) => {
    const event = getLocalEvent(
      localStatisticsActions.PRODUCT_MENU_SWIPER_INTERACTION
    );
    event.reportEvent({ status, interaction, item });
  },
  reportSurveyFeedback: (grade: number, currentView: string) => {
    const event = getLocalEvent(localStatisticsActions.SURVEY_FEEDBACK);
    event.reportEvent({ grade, currentView });
  },
  reportShowSurvey: () => {
    const event = getLocalEvent(localStatisticsActions.SHOW_SURVEY);
    event.reportEvent();
  },
  reportTerminateSurvey: () => {
    const event = getLocalEvent(localStatisticsActions.TERMINATE_SURVEY);
    event.reportEvent();
  },
  reportStartViewVpcEnterCodeSuccess: (configurationId: string) => {
    const event = getLocalEvent(
      localStatisticsActions.START_VIEW_VPC_ENTER_CODE_SUCCESS
    );
    event.reportEvent({ vpcCode: configurationId });
  },
  reportValidationError: (
    statisticsLabel: string,
    meansOfNotification: string
  ) => {
    const event = getLocalEvent(localStatisticsActions.VALIDATION_ERROR);
    event.reportEvent({ status: statisticsLabel, meansOfNotification });
  },
  reportNotLoaded: (reason: string, missingProductCategories: any) => {
    const event = getLocalEvent(localStatisticsActions.NOT_LOADED);
    event.reportEvent({ reason, missingProductCategories });
  },
  reportOpenPlanner: (entry: string, ...rest: Object[]) => {
    const event = getLocalEvent(localStatisticsActions.OPEN_PLANNER);
    event.reportEvent({ entry, ...rest }, { nonInteraction: true });
  },
  reportOpenPlannerVpcDeeplinkNotSupported: (vpcCode: Object) => {
    const event = getLocalEvent(
      localStatisticsActions.OPEN_PLANNER_VPC_DEEPLINK_NOT_SUPPORTED
    );
    event.reportEvent({ vpcCode }, { nonInteraction: true });
  },
  reportOpenPlannerSprDeeplinkNotSupported: (sprId: Object) => {
    const event = getLocalEvent(
      localStatisticsActions.OPEN_PLANNER_SPR_DEEPLINK_NOT_SUPPORTED
    );
    event.reportEvent({ sprId }, { nonInteraction: true });
  },
  reportSubPlannerUserChoice: (subPlanner: string) => {
    const event = getLocalEvent(localStatisticsActions.SUB_PLANNER_USER_CHOICE);
    event.reportEvent({ subPlanner });
  },
  reportSubPlannerAutomaticChoice: (subPlanner: string) => {
    const event = getLocalEvent(
      localStatisticsActions.SUB_PLANNER_AUTOMATIC_CHOICE
    );
    event.reportEvent({ subPlanner });
  },
  reportLanguageSelectorUserChoice: (
    fromLocale: string,
    toLocale: string,
    currentView: string
  ) => {
    const event = getLocalEvent(
      localStatisticsActions.LANGUAGE_SELECTOR_USER_CHOICE
    );
    event.reportEvent({ fromLocale, toLocale, currentView });
  },
  reportProductMenuSubFilterInteraction: (
    filter: string,
    subFilter: string,
    option: string
  ) => {
    const event = getLocalEvent(
      localStatisticsActions.PRODUCT_MENU_SUB_FILTER_INTERACTION
    );
    event.reportEvent({ filter, subFilter, option });
  },
  reportSeriesGalleryUsage: () => {
    const event = getLocalEvent(localStatisticsActions.SERIES_GALLERY_USAGE);
    event.reportEvent();
  },
  reportAmeliorationDialogShown: () => {
    const event = getLocalEvent(
      localStatisticsActions.AMELIORATION_DIALOG_SHOWN
    );
    event.reportEvent();
  },
  reportAmeliorationDialogAccepted: () => {
    const event = getLocalEvent(
      localStatisticsActions.AMELIORATION_DIALOG_ACCEPTED
    );
    event.reportEvent();
  },
  reportAmeliorationDialogDeclined: () => {
    const event = getLocalEvent(
      localStatisticsActions.AMELIORATION_DIALOG_DECLINED
    );
    event.reportEvent();
  },
  reportAmeliorationAttempt: (error: string) => {
    const event = getLocalEvent(localStatisticsActions.AMELIORATION_ATTEMPT);
    event.reportEvent({ error });
  },
  reportAmeliorationCanNotBeSolved: (error: string) => {
    const event = getLocalEvent(
      localStatisticsActions.AMELIORATION_CAN_NOT_BE_SOLVED
    );
    event.reportEvent({ error });
  },
  reportAmeliorationSolved: (error: string) => {
    const event = getLocalEvent(localStatisticsActions.AMELIORATION_SOLVED);
    event.reportEvent({ error });
  },
  reportAmeliorationDeclined: (error: string) => {
    const event = getLocalEvent(localStatisticsActions.AMELIORATION_DECLINED);
    event.reportEvent({ error });
  },
};
export default localStatisticsReporter;
